<template>
  <select>
    <slot></slot>
  </select>
</template>

<script>
  export default {
    props: ["filter", "value"],
    mounted() {
      let vm = this;

      vm.$nextTick(() => {
        $(vm.$el)
          .select2({
            data: vm.prepareOption,
            placeholder: vm.filter.placeholder || this.trans('Seçiniz..'),
            multiple: vm.filter.multiple,
            closeOnSelect: vm.filter.closeOnSelect
          })
            .val(vm.value)
            .trigger("change")
            .on("change", function (e) {
              if (this.value) {
                let val = this.value;

                if (vm.filter.multiple) {
                  val = [];
                  $(vm.$el).select2('data').forEach((item) => {
                    val.push(item.id);
                  })

                  if (!vm.filter.closeOnSelect) {
                    $(vm.$el).select2('close');
                    $(vm.$el).select2('open');
                  }
                }

                vm.$emit("input", val);
              }
            });
      })
    }, // end mount

    watch: {
      value: function (value) {
        if (!value) {
          $(this.$el).val(value).trigger('change');
        }
      },
    },

    computed: {
      prepareOption() {
        let option = [];
        for (const [key, value] of Object.entries(this.filter.option)) {
          option.push({
            id: key,
            text: value
          });
        }
        return option;
      }
    },

    destroyed: function () {
      $(this.$el).off().select2("destroy");
    }
  }
</script>

<style lang="scss">
  .select2-search--dropdown .select2-search__field {
    padding: .3rem .6rem .3rem 1.9rem;
  }

  .select2-search--dropdown {
    padding: .5rem;

    &:after {
      left: 1.2rem;
    }
  }
</style>
